export function isValidDate(value) {
  const timestamp = Date.parse(value)
  return !isNaN(timestamp)
}

export function isDate(date) {
  if (date && typeof date.getMonth === 'function') return true
  if (typeof date !== 'string') return false
  var dateformat = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))T?.*/
  return date.match(dateformat)
}

export function formatDateTimeToString(date, locale) {
  return date.toLocaleString(locale || 'it-IT', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour12: false,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}
